import { useCallback, useEffect, useState } from "react";
import { Outlet, useParams, useSearchParams } from "react-router-dom";
import useCategories from "../../../Hooks/useCategories";
import { UseVideoContext } from "../../Contexts/VideoContext";

export default function FullVideoListLayout() {
  const { categories, sort } = useParams();
  const [topVideo, setTopVideo] = useState(null);
  const [loadingTopVideo, setLoadingTopVideo] = useState(false);
  const { GetVideos, ChangeRecommendedVideos } = UseVideoContext();
  const categoryIds = useCategories(categories);
  const [searchParams] = useSearchParams();

  const catPassword = searchParams.get("cat_pas");
  const searchQuery = searchParams.get("search");

  const GetTopVideo = useCallback(async () => {
    let response = await GetVideos({
      amount: 1,
      categories: categoryIds,
      sortBy: sort ?? "date",
      password: catPassword,
      search: searchQuery,
    });

    if (response.status === 200 && response.data.length > 0) {
      const fetched = response.data[0];
      setTopVideo(fetched);
    }
  }, [GetVideos, sort, catPassword, searchQuery, categoryIds]);

  const GetRandomVideos = useCallback(async () => {
    let response = await GetVideos({
      amount: 6,
      categories: categoryIds,
      password: catPassword,
      random: true,
    });

    if (response.status === 200 && response.data.length > 0) {
      ChangeRecommendedVideos(response.data);
    }
  }, [GetVideos, ChangeRecommendedVideos, catPassword, categoryIds]);

  useEffect(() => {
    async function fetchVideos() {
      setLoadingTopVideo(true);
      await Promise.all([GetTopVideo(), GetRandomVideos()]);
      setLoadingTopVideo(false);
    }
    fetchVideos();
  }, [GetTopVideo, GetRandomVideos]);

  return (
    <div className="video-layout">
      <Outlet
        context={{ topVideo: topVideo, loadingTopVideo: loadingTopVideo }}
      />
    </div>
  );
}
